import { z } from 'zod';

import { versionSchema } from './common.schema.js';

export const sexSchema = z.enum(['female', 'male']);
export const goalSchema = z.enum(['cut', 'maintain', 'gain']);
export const activitySchema = z.enum(['sedentary', 'light', 'moderate', 'active', 'athlete']);

export const profileFieldsSchema = z.strictObject({
  sex: sexSchema,
  age: z.number().int().min(13).max(120),
  heightIn: z.number().int().min(36).max(96),
  weightLb: z.number().min(50).max(1000),
  goalWeightLb: z.number().min(50).max(1000).nullable(),
  goal: goalSchema,
  rateLbPerWeek: z.number().min(0).max(4),
  proteinPerLb: z.number().min(0.5).max(2),
  activity: activitySchema,
  dailyGoal: z.number().int().min(0).max(10_000),
  // Optional override for days with no workout and no session. Zero means "work it out for
  // me", matching how `dailyGoal` already treats zero, so one convention covers both.
  restDayCalories: z.number().int().min(0).max(10_000).default(0),
  maintenanceCalories: z.number().int().min(1000).max(10_000).nullable().default(null),
  zip: z.string().regex(/^\d{5}$/, 'Expected a five digit ZIP code').or(z.literal('')),
  phone: z.string().regex(/^\+[1-9]\d{7,14}$/, 'Use international format, for example +15551234567').or(z.literal('')).default(''),
  nearbyRadiusMiles: z.number().int().min(1).max(25).default(10),
  measurementSystem: z.enum(['us', 'metric']).default('us'),
});

export const saveProfileRequestSchema = profileFieldsSchema.extend({ version: versionSchema });
